/* istanbul ignore file */
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ISelectedContract, LoggedInUserSettings } from '../services/settings/logged-in-user-settings';
import { dashboardRouteWithSlash } from '../../route-constants';
import { ADPResourceService } from 'digital-core';

@Injectable({
  providedIn: 'root',
})
export class ContractGuard {
  constructor(
    private location: Location,
    private router: Router,    
    private resourceService: ADPResourceService,
  ) {
  }

  activateGuard(contract: ISelectedContract, isSecondaryUserAllowed = true, checkExpiration = true, checkCancellation = true): boolean {
    let isEnabled = false;
    const cancelledOrExpiredHasFullAccess = this.resourceService.isPortalSettingTrue('Global_CancelledOrExpiredContract_HasFullAccess');

    // if Contract is not expired then allow the user to proceed. 
    if (checkExpiration && !checkCancellation) {
      isEnabled = !contract.isExpired || cancelledOrExpiredHasFullAccess;
    }
    else if (checkExpiration && checkCancellation) {
      if (!contract.isPrimary) {
        isEnabled = (!contract.isExpired && !contract.isCancelled) || cancelledOrExpiredHasFullAccess && isSecondaryUserAllowed;
      } else {
        isEnabled = (!contract.isExpired && !contract.isCancelled) || cancelledOrExpiredHasFullAccess;
      }
    } else if (!checkExpiration && checkCancellation) {
      if (!contract.isPrimary) {
        isEnabled = (!contract.isCancelled || cancelledOrExpiredHasFullAccess) && isSecondaryUserAllowed;
      } else {
        isEnabled = (!contract.isCancelled || cancelledOrExpiredHasFullAccess);
      }
    }

    if (isEnabled) {
      return true;
    }
    else {
      this.goBack();
      return false;
    }
  }

  goBack() {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate([dashboardRouteWithSlash]);
    }
  }
}
